import { AcctItem, FundAcctInfo, FundAcctState } from 'scbk-shared-module/types/fund-types';
import { create } from 'zustand';

/**
 *
 */
export const useFundAcctStore = create<FundAcctState>()((set) => ({
  fundList: undefined,
  updateFundAcctState: (fundAcctList) => {
    let converted = [] as FundAcctInfo[];
    fundAcctList.forEach((item: AcctItem) => {
      const res = {
        acctNum: item.drawAcctNum,
        currency: item.curcy,
        fundCode: item.fundCode,
        fcyFundToggle:
          !['7', '8', '9'].includes(item.fundCode.slice(3, 4)) && !['', 'KRW'].includes(item.curcy)
            ? true
            : false,
      };
      converted.push(res);
    });
    set({ fundList: converted });
  },
  clear: () => set({ fundList: undefined }),
}));
